module.exports = __webpack_public_path__ + "static/media/tunna-min.4adf0431.png";